import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import Divider from "components/ui/Divider";
import TextLink from "hardcover-ui/components/TextLink";
import BookCharacterLink from "components/characters/BookCharacterLink";
import { PageSerializersBooksShow } from "types/serializers";

export default function TopBookCharacters({
  book,
  limit,
}: {
  book: PageSerializersBooksShow;
  limit: number;
}) {
  const { bookCharacters } = book;
  if (!bookCharacters || bookCharacters.length == 0) {
    return false;
  }

  const characters = bookCharacters.slice(0, limit);

  return (
    <Container variant="layout" size="md">
      <div className="flex justify-between items-baseline">
        <Heading level={2} size="md">
          Characters
        </Heading>
        <TextLink
          href={`/books/${book.slug}/characters`}
          size="sm"
          className="flex space-x-1"
        >
          See all ({book.charactersCount})
        </TextLink>
      </div>

      <div className="mt-4 grid grid-cols-2 lg:grid-cols-3 gap-4">
        {characters.map((bookCharacter) => (
          <BookCharacterLink
            key={bookCharacter.character.id}
            bookCharacter={bookCharacter}
          />
        ))}
      </div>

      <Divider size="lg" />
    </Container>
  );
}
